import * as React from 'react';
export const IcDoorOpen = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 2h-6.53l3.26 1.22A3.52 3.52 0 0117 6.5V20h1a2 2 0 002-2V4a2 2 0 00-2-2zm-4 3.1l-8-3a1.39 1.39 0 00-.5-.1 1.46 1.46 0 00-.85.27A1.49 1.49 0 004 3.5v13.3a1.5 1.5 0 00.87 1.36l8 3.7c.198.09.413.138.63.14a1.51 1.51 0 001.5-1.5v-14a1.5 1.5 0 00-1-1.4zm-2 8.4a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
